<div class="img" *ngIf="userInfo?.profile_pic">
    <img [src]="userInfo?.profile_pic.full_url" alt="" />
</div>
<div fxLayout="column" fxFlex="24px" class="name img member" fxLayoutAlign="center center" *ngIf="!userInfo?.profile_pic">
    <div class="name-text">{{userInfo?.avatar_text.charAt(0)}}</div>
</div>